import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews.js';

// Include all block.js / block.vue's, except form admin. Include from this module as well as from the app.
AutoloadViews.load('website::admin', require.context('./admin', true, /^(.*).(js|vue)$/));
